import React from "react";
import { CoverImageUploadLoaderTemplate } from "themes/common/components";

function CoverImageUploadLoader(props) {
    return <CoverImageUploadLoaderTemplate {...props} />;
}

export default CoverImageUploadLoader;
